// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"59336051","180":"1ec55cf8","208":"dcdbdde0","627":"efb1c059","631":"b3fa1439","774":"d3012f0d","787":"e3835ec5","910":"ff1276ca"}[chunkId] + ".chunk.js";
};